export default {
    app: {
        name: 'Forecaster',
        title: 'Forecaster',
        loading: 'Chargement...',
        error: 'Une erreur est survenue.',
        saved: 'Enregistré',
        save: 'Enregistrer',
    },
    home: {
        welcome: 'Bienvenue dans Forecaster!',
        upcomingRain: 'Prochaines pluies',
        searchLocation: 'Rechercher un lieu',
        loadingData: 'Chargement des données météo...',
        findingLocation: 'Recherche de votre position...',
        geolocationError: 'Impossible d\'obtenir la position actuelle. Veuillez activer les services de localisation ou rechercher un lieu.',
        offlineError: 'Vous semblez être hors ligne. Veuillez vérifier votre connexion internet.',
        serverError: 'Un problème est survenu lors de la connexion à notre serveur. Veuillez réessayer plus tard.',
        forecastUnavailableError: 'Aucune prévision actuelle n’est disponible pour ce lieu. Veuillez réessayer plus tard.',
        currentLocation: 'Position actuelle',
        fetchError: 'Échec du chargement des données météo. Veuillez réessayer plus tard.',
        retry: 'RÉESSAYER',
        byMetNo: 'Propulsé par YR.no',
        byMeteoFrance: 'Propulsé par Météo-France',
        byAppleWeather: 'Propulsé par {appleIcon} Weather',
        byGoogleWeather: 'Propulsé par Google Weather',
        validUntil: 'Valide jusqu\'à {time}',
        loadedAt: 'Chargé à {time}',
        currently: 'Actuellement',
        thisWeek: 'Cette semaine',
        today: 'Aujourd\'hui',
        tomorrow: 'Demain',
        geolocationErrorGeneric: 'Une erreur est survenue lors de la détection de votre position.',
        geolocationPermissionDenied: 'L\'accès à la localisation a été refusé. Veuillez autoriser le partage de la localisation dans les paramètres de votre navigateur pour continuer.',
        geolocationPositionUnavailable: 'Nous n\'avons pas pu déterminer votre position. Cela peut être dû à un mauvais signal ou à des services de localisation désactivés.',
        geolocationTimeout: 'La recherche de votre position prend trop de temps. Veuillez réessayer ou vérifier votre connexion.',
        geolocationUnsupported: 'La localisation n\'est pas disponible dans ce navigateur ou ce contexte. Utilisez HTTPS ou recherchez un lieu.',
        geolocationPromptRequired: 'Appuyez sur Réessayer pour autoriser l\'accès à la position et continuer.',
        providerError: 'Impossible de charger les données de {providerName}. Ils rencontrent peut-être des problèmes. Veuillez réessayer plus tard.'
    },
    units: {
        precipitation: {
            mm: '{value} mm',
            in: '{value} po',
        },
    },
    drawer: {
        currentLocation: 'Position actuelle',
        starredLocations: 'Lieux favoris',
        starToSave: 'Mettez un lieu en favori pour l\'enregistrer ici.',
        settings: 'Paramètres',
        colorGuide: 'Guide couleurs',
        feedback: 'Envoyer un avis',
        helpTranslate: 'Aidez à la traduction',
    },
    colorGuide: {
        title: 'Guide couleurs',
        clear: 'Dégagé',
        clear_explanation: 'Pas de précipitation attendue et moins de 25% du ciel sera couvert.',
        partly_cloudy: 'Partiellement couvert',
        partly_cloudy_explanation: 'Entre 25% et 75% du ciel sera couvert. Pas de précipitation attendue.',
        cloudy: 'Nuageux',
        cloudy_explanation: 'Plus de 75% du ciel sera couvert. Pas de précipitation attendue.',
        scattered_rain: 'Pluie éparse',
        scattered_rain_explanation: 'Il va pleuvoir dans la zone, mais nous ne sommes pas sûr s\'il va pleuvoir là où vous êtes exactement.',
        rain: 'Pluie',
        rain_explanation: 'Il y a une forte probabilité de pluie.',
        scattered_snow: 'Neige éparse',
        scattered_snow_explanation: 'Il va neiger dans la zone, mais nous ne sommes pas sûr s\'il va neiger là où vous êtes exactement.',
        snow: 'Neige',
        snow_explanation: 'Il y a une forte probabilité de neige.',
    },
    settings: {
        title: 'Paramètres',
        wind_speed_units_default: 'kmh',
        temperature_units_default: 'celsius',
        night_mode_default: 'system',
        units: 'Unités',
        temperature_units: 'Température',
        wind_speed_units: 'Vitesse du vent',
        precipitation_units: 'Précipitations',
        forecast: 'Prévision',
        hide_early_morning: 'Masquer les heures du petit matin',
        hide_early_morning_explanation: 'Afficher la météo à partir de 5h du matin plutôt que sur 24 heures',
        appearance: 'Apparence',
        theme: 'Thème',
        show_minMax: 'Afficher les températures Min/Max',
        show_minMax_summary: 'Afficher les températures min/max quotidiennes à côté des informations sur la pluie et les nuages',
        auto_expand_today: 'Développer automatiquement les prévisions d\'aujourd\'hui',
        about: 'À propos',
        privacy_policy: 'Politique de confidentialité',
        terms_of_service: 'Conditions d\'utilisation',
        provider: 'Fournisseur',
        data_source: 'Source de données',
        language: 'Langue',
        unit_selection: {
            celsius: 'Celsius',
            fahrenheit: 'Fahrenheit',
        },
        wind_speed_unit_selection: {
            mph: 'mph',
            knots: 'nœuds',
            kmh: 'km/h',
            ms: 'm/s',
            beaufort: 'Échelle de Beaufort',
        },
        precipitation_unit_selection: {
            mm: 'mm',
            inches: 'pouces',
        },
        night_mode_options: {
            system: 'Défaut du système',
            light: 'Clair',
            dark: 'Sombre',
        },
        data_source_options: {
            auto: 'Automatique',
            metno: 'YR.no',
            meteofrance: 'Météo-France',
            appleweather: 'Apple Weather',
            googleweather: 'Google Weather',
        },
        language_selection: {
            en: 'English',
            de: 'Deutsch',
            es: 'Español',
            fr: 'Français',
            it: 'Italien',
        }
    },
    provider_modal: {
        title: 'Choisissez votre source de données météo',
        close_modal: 'Fermer la sélection du fournisseur',
        cancel: 'Annuler',
        save: 'Enregistrer',
        metno_desc: 'Prévisions mondiales de confiance de l\'Institut météorologique norvégien.',
        meteofrance_desc: 'Prévisions détaillées et à haute résolution pour la France.',
        appleweather_desc: 'Données précises et à haute résolution d\'Apple Weather.',
        googleweather_desc: 'Prévisions mondiales de haute qualité par Google.',
        auto_desc: 'Laissez l\'application choisir automatiquement la meilleure source pour votre emplacement.',
    },
    searchModal: {
        searchForLocation: 'Rechercher un lieu...',
        placeholder: 'Rechercher un lieu',
        closeModal: 'Fermer la recherche',
        googleMapsError: 'Erreur lors du chargement de la bibliothèque Google Maps Places:',
        googleMapsNotLoaded: 'La bibliothèque de l\'API JavaScript de Google Maps n\'est pas chargée.',
        placesLibraryError: 'La bibliothèque Places n\'est pas entièrement chargée ou le jeton de session est manquant.',
        fetchPredictionsError: 'Erreur lors de la récupération des prédictions de lieux:',
        fetchDetailsError: 'Erreur lors de la récupération des détails du lieu:',
        noInput: 'Commencez à taper pour rechercher des lieux.',
        noResults: 'Aucun résultat trouvé.',
        noRecentlyViewed: 'Aucun lieu récemment consulté.',
        searchUnavailable: 'La recherche est indisponible car les services Google sont bloqués par ce navigateur ou votre configuration.',
        searching: 'Recherche en cours...',
        recentlyViewed: 'Récemment consulté',
    },
    minutelyTimeline: {
        now: 'Maintenant',
        minutes: '{minutes}',
        minutesWithUnit: '{minutes} min',
    },
    upcomingRain: {
        maxIntensity: 'Forte',
        midIntensity: 'Modérée',
        minIntensity: 'Légère',
    },
    weeklyForecast: {
        rainCloud: 'Pluie & Nuages',
        temperature: 'Température',
        wind: 'Vent',
    },
    feedback: {
        title: 'Votre avis est le bienvenu',
        message: 'Vos retours m\'aident à améliorer Forecaster. Dites-moi ce que vous en pensez !',
        featureIdeas: 'Une idée de fonctionnalité ? N\'hésitez pas à la partager.',
        contactUs: 'Vous pouvez me contacter à',
        send: 'Envoyer un avis',
    },
    forecastInfo: {
        details: 'Informations sur les prévisions',
        explanation: 'Les prévisions météo sont mises à jour périodiquement par nos fournisseurs.',
        computed: 'Généré par le fournisseur',
        expires: 'Nouvelle prévision attendue',
        loaded: 'Téléchargé',
        close: 'Fermer',
    }
};
